import React from 'react'

const Meta = ({ lang }: { lang: string }) => (
  <React.Fragment>
    <meta content={lang} httpEquiv="content-language" />
    <meta content="width=device-width, initial-scale=1.0, maximum-scale=1" name="viewport" />
  </React.Fragment>
)

export default Meta
